export const InitialState = {
    id: null,
    viewState: 0,

    mainData: {},
    mainDict: {},
    mainDataChanged: false,

    revisionsInfo: [],
    hasRevisions: false,
};
